import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import Stack from "@kit/design/stack"
import Label from "@kit/design/label"
import { ColorInput } from "@kit/design/color-picker"
import PixelSlider from "@kit/design/pixel-slider"
import { Padding } from "./utils/padding"
import { BorderRadius } from "./utils/border-radius"
import { BorderSize } from "./utils/border-size"
import { Expander } from "app/regions/blocks/shared/expander"
import { ImageUploader } from "../header/utils/image-uploader"
import { SectionWidth, ContentWidth } from "./utils/width"
import { useSavedColors } from "hooks/use-saved-colors"

export function SectionSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <div className="p-4 pt-0">
      <Stack spacing={4}>
        <div>
          <Label htmlFor="backgroundColor">Background color</Label>
          <ColorInput
            id="backgroundColor"
            name="backgroundColor"
            onChange={color => update({ backgroundColor: color.hex })}
            value={properties.backgroundColor}
            savedColors={savedColors}
          />
          <div className="mt-2">
            <button
              className="px-2 py-1 border rounded text-sm text-gray-700 mr-2"
              onClick={() => update({ backgroundColor: "transparent" })}
            >
              Transparent
            </button>
          </div>
        </div>
        <ImageUploader
          label="Background image"
          name="backgroundImage"
          image={properties.backgroundImage}
          update={file =>
            update({
              backgroundImage: file.dataURL
            })
          }
          remove={() => update({ backgroundImage: "" })}
        />
      </Stack>
      <div className="mt-4">
        <Expander label="Spacing">
          <PixelSlider
            label="Space below section"
            name="marginBottom"
            value={properties.marginBottom}
            onChange={newValue => update({ marginBottom: newValue })}
            min={0}
            max={36}
          />

          <Padding properties={properties} update={update} />
          <SectionWidth properties={properties} update={update} />
          <ContentWidth properties={properties} update={update} />
        </Expander>
        <Expander label="Border">
          <Label htmlFor="borderColor">Border color</Label>
          <ColorInput
            id="borderColor"
            name="borderColor"
            onChange={color => update({ borderColor: color.hex })}
            value={properties.borderColor}
            savedColors={savedColors}
          />
          <BorderSize properties={properties} update={update} />
          <BorderRadius properties={properties} update={update} />
        </Expander>
      </div>
    </div>
  )
}
